<template>
  <div id="app">
    <header id="header">
      <div class="container">
        <div id="logo" class="pull-left">
          <h2>
            <a href="#body" class="scrollto">
              Kashi
              <span>Mamidisetti</span>
            </a>
          </h2>
        </div>

        <nav id="nav-menu-container">
          <ul class="nav-menu">
            <li class="menu-active">
              <a href="#body" class="link-effect">Home</a>
            </li>
            <li>
              <a href="#about">About Me</a>
            </li>
            <li>
              <a href="#skills">Skills</a>
            </li>
            <li>
              <a href="#experience">Experience</a>
            </li>
            <li>
              <a href="#education">Education</a>
            </li>
            <li>
              <a href="#contact">Contact</a>
            </li>
          </ul>
        </nav>
        <!-- #nav-menu-container -->
      </div>
    </header>
    <section id="intro">
      <div class="intro-content">
        <h2 class="fullstack" title="Kashi Mamidisetti">
          React.js
          <br />Developer
        </h2>
        <div>
          <a href="#about" class="btn-get-started scrollto">About Me</a>
          <!-- <a
            href="https://github.com/Kasilucky?tab=repositories"
            target="_blank"
            class="btn-projects scrollto project"
            >My Projects</a
          > -->
        </div>
      </div>

      <div id="intro-carousel" class="owl-carousel">
        <div
          class="item"
          style="background-image: url('img/computer-world.png')"
        ></div>
        <div
          class="item"
          style="background-image: url('img/Server-Programming.jpg')"
        ></div>
        <div
          class="item"
          style="background-image: url('img/s-image.jpg')"
        ></div>
        <div
          class="item"
          style="background-image: url('img/xmedium.jpg')"
        ></div>
      </div>
    </section>
    <!-- #intro -->
    <main id="main">
      <section id="about" class="wow fadeInUp">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 about-img">
              <img src="img/react-n.png" alt />
            </div>

            <div class="col-lg-6 content">
              <h2 title="Kashi Mamidisetti">Senior Software Engineer</h2>
              <span class="ml-3 mb-5">
                - at Incedo Inc ( Oct 2023 - Present )</span
              >
              <p>
                (+91) 7893138010.
                <a href="mailto:kasimca44@gmail.com">kasimca44@gmail.com</a>
              </p>
              <h3>
                5.3 + Years of Experience as a React.js Developer and its frameworks etc...
              </h3>
              <ul class="fa-ul mb-0 experience">
                <li>
                  <i class="fa-li fa fa-check"></i>
                  Knowledge on multiple Front-End Technologies<br />
                  (e.g. HTML/CSS/BootStrap/Material-UI and etc...)
                </li>
                <li>
                  <i class="fa-li fa fa-check"></i>
                  Knowledge on Back-End languages like NodeJs, NestJs, GraphQL and etc...
                </li>
                <li>
                  <i class="fa-li fa fa-check"></i>
                  Knowledge on MongoDB, PostgreSQL, AWS and etc...
                </li>
                <li>
                  <i class="fa-li fa fa-check"></i>
                  Knowledge on Git, Splunk, Kibana.
                </li>
                <li>
                  <i class="fa-li fa fa-check"></i>
                  Good communication and team work skills
                </li>
                <li>
                  <i class="fa-li fa fa-check"></i>
                  Strong collaboration skills
                </li>
                <li>
                  <i class="fa-li fa fa-check"></i>
                  Teamwork
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section id="skills">
        <div class="container">
          <div class="section-header">
            <h2>Skills</h2>
            <div class="subheading mb-3">Workflow</div>
            <ul class="fa-ul mb-0">
              <li>
                <i class="fa-li fa fa-check"></i>
                Creating Responsive Applications and Reusable Components for
                Web/Desktop/Mobile.
              </li>
              <li>
                <i class="fa-li fa fa-check"></i>
                Follow all company standards to create top-quality applications.
              </li>
              <li>
                <i class="fa-li fa fa-check"></i>
                Enhance the functionalities of existing modules.
              </li>
              <li>
                <i class="fa-li fa fa-check"></i>
                Design client-side and server-side architecture.
              </li>
              <li>
                <i class="fa-li fa fa-check"></i>
                Troubleshooting software bugs and issues.
              </li>
              <li>
                <i class="fa-li fa fa-check"></i>
                Deployment and Maintenance.
              </li>
            </ul>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="box wow fadeInLeft" data-wow-delay="0.2s">
                <div class="icon icon-html"></div>
                <h4 class="title">
                  <a href>HTML</a>
                </h4>
                <div class="progress md-progress">
                  <div
                    class="progress-bar bg-success progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    style="width: 80%"
                    aria-valuenow="80"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="box wow fadeInRight" data-wow-delay="0.2s">
                <div class="icon icon-css"></div>
                <h4 class="title">
                  <a href>CSS</a>
                </h4>
                <div class="progress md-progress" style="margin-left: 70px">
                  <div
                    class="progress-bar bg-danger progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    style="width: 70%"
                    aria-valuenow="70"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="box wow fadeInLeft kill">
                <div class="icon icon-js"></div>
                <h4 class="title">
                  <a href>JavaScript</a>
                </h4>
                <div class="progress md-progress">
                  <div
                    class="progress-bar bg-primary progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    style="width: 80%"
                    aria-valuenow="80"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="box wow fadeInRight">
                <div class="icon icon-react"></div>
                <h4 class="title">
                  <a href>React.js</a>
                </h4>
                <div class="progress md-progress">
                  <div
                    class="progress-bar bg-dark progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    style="width: 80%"
                    aria-valuenow="80"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="clients" class="wow fadeInUp">
        <div class="container">
          <div class="section-header">
            <h2>PROGRAMMING LANGUAGES & TOOLS</h2>
          </div>

          <div class="owl-carousel clients-carousel">
            <img src="img/html.png" alt height="200px" />
            <img src="img/css3.png" alt height="200px" />
            <img src="img/js.jpg" alt height="200px" />
            <img src="img/reactjs.png" alt height="200px" />
            <img src="img/vue.png" alt height="200px" />
            <img src="img/node.jpg" alt height="200px" />
            <img src="img/aws.png" alt height="200px" />
            <img src="img/mongo.png" alt height="200px" />
          </div>
        </div>
      </section>
      <section id="experience" class="wow fadeInUp">
        <div class="container">
          <div class="section-header">
            <h2>Experience</h2>
          </div>
        </div>
        <div class="container">
          <div class="section-header">
            <h2>Senior Software Engineer</h2>
            <h5>
              at Incedo Inc, From Oct 2023 - Present.
              <span style="font-size: 14px"
                >-
                <a
                  href="https://www.incedoinc.com/"
                  style="color: #ef4815 !important"
                  target="_blank"
                  >About Company</a
                ></span
              >
            </h5>
            <p>
              Here, I have worked on NSP Admin portal which is allow NRB users to manage outages, view reports for any network activities.
              Implementing new screens and API's with latest technologies.
            </p>
          </div>
          <div class="section-header">
            <h2>Associate</h2>
            <h5>
              at Cognizant Technology Solutions, From Jun 2021 - Sep 2023.
              <span style="font-size: 14px"
                >-
                <a
                  href="https://www.cognizant.com/in/en"
                  style="color: blue !important"
                  target="_blank"
                  >About Company</a
                ></span
              >
            </h5>
            <p>
              Here, I have developed Web applications and Reusable Components by
              using React.js and worked on multiple tools like Transmit, Kibana
              and Splunk, ..etc, Here The Management is pretty good.
            </p>
          </div>
          <div class="section-header">
            <h2>Software Engineer</h2>
            <h5>
              at STELLENT SOFT PVT LTD, From May 2019 - May 2021.
              <span style="font-size: 14px"
                >-
                <a
                  href="https://www.thecompanycheck.com/company/stellent-soft-private-limited/U72200AP2008PTC058511"
                  style="color: blue !important"
                  target="_blank"
                  >About Company</a
                ></span
              >
            </h5>
            <p>
              Here, we get exposed to the latest technologies. I have developed
              Web applications by using React.js, Gatsby, Next.js and Mobile
              applications by using React-Native. The technical expertise is
              pretty good. I have learned a lot in a short span of time.
            </p>
          </div>
        </div>
        <div class="container">
          <div class="section-header">
            <h2>3 MONTHS INTERNSHIP</h2>
            <h5>
              at CODING SASTRA, Vizag
              <span style="font-size: 14px"
                >-
                <a
                  href="https://www.codingsastra.com/"
                  style="color: blue !important"
                  target="_blank"
                  >About Coding Sastra</a
                ></span
              >
            </h5>
            <p>
              Coding Sastra is a best place for doing a course where I got
              knowledge on MERN stack. It provides very good environment for
              learning. The staff are supportive and clarify doubts at anytime.
              Here we can learn the complete knowledge of Web development, App
              development, Server Maintenance.
            </p>
          </div>
        </div>
      </section>

      <section id="education" class="wow fadeInUp">
        <div class="container">
          <div class="section-header">
            <h2>Education</h2>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="member edu2">
                <div class="details" style="height: 150px">
                  <h4>
                    <a href="http://www.bvricedegree.edu.in/" target="_blank"
                      >PADMASRI B. V RAJU INSTITUTE OF TECHNOLOGY</a
                    >
                  </h4>
                  <span>MASTER OF COMPUTER APPLICATIONS(MCA)</span>
                  <span>7.52</span>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="member edu">
                <div class="details" style="height: 150px">
                  <h4>
                    <a href="http://www.sriyncollege.org/" target="_blank"
                      >SRI Y N COLLEGE</a
                    >
                  </h4>
                  <span>BACHELOR OF SCIENCE(BSc)</span>
                  <span>6.8</span>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="member edu1">
                <div class="details" style="height: 150px">
                  <h4>
                    <a href="http://www.sriyncollege.org/" target="_blank"
                      >SRI Y N COLLEGE</a
                    >
                  </h4>
                  <span>INTERMEDIATE</span>
                  <span>55%</span>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="member edu3">
                <div class="details" style="height: 150px">
                  <h4>
                    <a href="#education">Z. P. HIGH SCHOOL</a>
                  </h4>
                  <span>SSC</span>
                  <span>48%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="contact" class="wow fadeInUp">
        <div class="container">
          <div class="section-header">
            <h2>Contact Me</h2>
          </div>
          <div class="row contact-info">
            <div class="col-md-4">
              <a
                href="https://en.wikipedia.org/wiki/Bhimavaram"
                target="_blank"
              >
                <div class="contact-address">
                  <i class="fa fa-address-book"></i>
                  <h3>Address</h3>
                  <address>Bhimavaram, W.G Dist, A.P, 534201.</address>
                </div>
              </a>
            </div>
            <div class="col-md-4">
              <a href="tel:+91 7893138010">
                <div class="contact-phone">
                  <i class="fa fa-phone"></i>
                  <h3>Phone Number</h3>
                  <p>
                    <a href="tel:+91 7893138010">+91 7893138010</a>
                  </p>
                </div>
              </a>
            </div>

            <div class="col-md-4">
              <a href="mailto:kasimca44@gmail.com">
                <div class="contact-email">
                  <i class="fa fa-envelope"></i>
                  <h3>Email</h3>
                  <p>
                    <a href="mailto:kasimca44@gmail.com">kasimca44@gmail.com</a>
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>

        <!-- <div class="container mb-4">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d22864.11283411948!2d-73.96468908098944!3d40.630720240038435!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew+York%2C+NY%2C+USA!5e0!3m2!1sen!2sbg!4v1540447494452"
            width="100%"
            height="380"
            frameborder="0"
            style="border:0"
            allowfullscreen
          ></iframe>
        </div>-->
        <div class="container">
          <div class="form">
            <form action role="form" class="contactForm">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <input
                    type="text"
                    v-model="name"
                    name="name"
                    class="form-control"
                    id="name"
                    placeholder="Your Name"
                    data-rule="minlen:3"
                    data-msg="Please enter at least 3 chars"
                    required
                  />
                </div>
                <div class="form-group col-md-6">
                  <input
                    type="email"
                    v-model="email"
                    class="form-control"
                    name="email"
                    id="email"
                    placeholder="Your Email"
                    data-rule="email"
                    data-msg="Please enter a valid email"
                    required
                  />
                </div>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  v-model="subject"
                  class="form-control"
                  name="subject"
                  id="subject"
                  placeholder="Subject"
                  data-rule="minlen:4"
                  data-msg="Please enter at least 8 chars of subject"
                  required
                />
              </div>
              <div class="form-group">
                <textarea
                  v-model="message"
                  class="form-control"
                  name="message"
                  rows="5"
                  data-rule="required"
                  data-msg="Please write something for us"
                  placeholder="Message"
                  required
                ></textarea>
              </div>
              <div class="text-center">
                <button type="submit" class="project" @click="addContact">
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </main>
    <footer id="footer">
      <div class="container footerscoical">
        <div class="copyright" style="padding: 10px 10px 10px 10px">
          <a
            href="https://www.facebook.com/Kashi.Mamidisetti"
            target="_blank"
            class="footerslinks"
          >
            <i class="fa fa-facebook-official" style="font-size: 40px"></i>
          </a>
          <a
            href="https://twitter.com/KasiMamidisetti"
            target="_blank"
            class="footerslinks"
          >
            <i class="fa fa-twitter" style="font-size: 40px"></i>
          </a>
          <a
            href="https://www.linkedin.com/in/kashi-mamidisetti/"
            target="_blank"
            class="footerslinks"
          >
            <i class="fa fa-linkedin" style="font-size: 40px"></i>
          </a>
          <a
            href="https://stackoverflow.com/users/22047289/kashi-mamidisetti"
            target="_blank"
            class="footerslinks"
          >
            <i class="fa fa-stack-overflow" style="font-size: 40px"></i>
          </a>
          <a href="https://github.com/kashi-mamidisetti" target="_blank">
            <i class="fa fa-github" style="font-size: 40px"></i>
          </a>
        </div>
        <div class="credits" style="color: white">
          Follow Me On
          <a href="#footer" style="color: white">Scocial Media</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import gql from "graphql-tag";
import Swal from "sweetalert2";
export default {
  name: "app",
  data() {
    return {
      name: "",
      email: "",
      message: "",
      subject: "",
    };
  },
  methods: {
    addContact() {
      if (
        (this.email === "" && this.name === "",
        this.message === "",
        this.message === "")
      ) {
        Swal.fire("Please Enter All Details");
      } else {
        this.$apollo
          .mutate({
            mutation: gql`
              mutation (
                $name: String!
                $email: String!
                $message: String!
                $subject: String!
              ) {
                createContact(
                  name: $name
                  email: $email
                  message: $message
                  subject: $subject
                ) {
                  id
                  name
                  email
                  message
                  subject
                }
              }
            `,
            // Parameters
            variables: {
              name: this.name,
              email: this.email,
              message: this.message,
              subject: this.subject,
            },
          })
          .then(
            Swal.fire({
              icon: "success",
              title:
                "Your Contact information is successfully saved i will contact you soon...",
              showConfirmButton: false,
              timer: 3000,
            })
          )
          // eslint-disable-next-line no-console
          .then((data) => console.log(data))
          .then(
            (this.name = ""),
            (this.email = ""),
            (this.message = ""),
            (this.subject = "")
          )
          // eslint-disable-next-line no-console
          .catch((err) =>
            Swal.fire({
              title: "Error!",
              text: `Do you want to continue${err}`,
              icon: "error",
              confirmButtonText: "Cool",
            })
          );
      }
    },
  },
};
</script>
